import React from 'react';

import VersionGrid from './VersionGrid';
import VersionCard from './VersionCard';

import versions from './versions.json'

export default () => {

		return (
			<React.Fragment>
				<VersionGrid>
					{versions.map(versionData => (
						<VersionCard key={versionData.version} versionData={versionData}/>
					))}
				</VersionGrid>
			</React.Fragment>
		);
};
